import { Usage } from 'containers/Usage'

export default Usage
